import React, { SVGProps } from 'react';
import SVG from '.';
import { SVGIconSine } from './SVGIconSine';
import { SVGIconAccount } from './SVGIconAccount';
import { SVGIconGear } from './SVGIconGear';
import { SVGIconBack } from './SVGIconBack';
import { SVGIconSearch } from './SVGIconSearch';
import { SVGIconSearchPrice } from './SVGIconSearchPrice';
import { SVGIconCreateBanner } from './SVGIconCreateBanner';
import { SVGIconFolder } from './SVGIconFolder';
import SVGIconAngle from './SVGIconAngle';
import SVGIconFilter from './SVGIconFilter';
import { SVGIconPrev } from './SVGIconPrev';
import { SVGIconClose } from './SVGIconClose';
import { SVGIconEye } from './SVGIconEye';
import { SVGIconSave } from './SVGIconSave';
import { SVGIconEdit } from './SVGIconEdit';
import { SVGIconTrash } from './SVGIconTrash';
import { SVGIconLoader } from './SVGIconLoader';
import { SVGIconBroom } from './SVGIconBroom';
import { SVGIconCheck } from './SVGIconCheck';
import { SVGIconUncheck } from './SVGIconUncheck';
import SVGIconPasswordEye from './SVGIconPasswordEye';
import { SVGIconPlus } from './SVGIconPlus';
import { SVGIconMinus } from './SVGIconMinus';
import SVGIconArrow from './SVGIconArrow';
import { SVGIconCreateTicket } from './SVGIconCreateTicket';
import { SVGIconPin } from './SVGIconPin';
import { SVGIconPrinter } from './SVGIconPrinter';
import { SVGIconSaveAsh } from './SVGIconSaveAsh';
import { SVGIconGrayBroom } from './SVGIconGrayBroom';
import { SVGIconGrayPrinter } from './SVGIconGrayPrinter';
import { SVGIconArrowDuplo } from './SVGIconGrayPrinterDuplo';
import { SVGIconBackSet } from './SVGIconBackSet';
import { SVGIconReturnRightSet } from './SVGIconReturnRightSet';
import { SVGIconArrowRightDuplo } from './SVGIconSVGIconArrowRightDuplo';
import { SVGIconCloseSmall } from './SVGIconCloseSmall';
import { SVGIconRoundedClose } from './SVGIconRoundedClose';
import { SVGIconDownload } from './SVGIconDownload';
import { SVGIconUnlock } from './SVGIconUnlock';
import { SVGIconLock } from './SVGIconLock';
import { SVGIconDuplicate } from './SVGIconDuplicate';

export default Object.assign(
  ({ children, ...rest }: SVGProps<any>) => {
    return <SVG {...rest}>{children}</SVG>;
  },
  {
    Arrow: SVGIconArrow,
    Sine: SVGIconSine,
    Account: SVGIconAccount,
    Gear: SVGIconGear,
    Back: SVGIconBack,
    Search: SVGIconSearch,
    SearchPrice: SVGIconSearchPrice,
    CreateBanner: SVGIconCreateBanner,
    CreateTicket: SVGIconCreateTicket,
    Folder: SVGIconFolder,
    Angle: SVGIconAngle,
    Filter: SVGIconFilter,
    Prev: SVGIconPrev,
    Close: SVGIconClose,
    Edit: SVGIconEdit,
    Eye: SVGIconEye,
    Save: SVGIconSave,
    Trash: SVGIconTrash,
    Loader: SVGIconLoader,
    Broom: SVGIconBroom,
    Check: SVGIconCheck,
    Uncheck: SVGIconUncheck,
    PasswordEye: SVGIconPasswordEye,
    Plus: SVGIconPlus,
    Minus: SVGIconMinus,
    Pin: SVGIconPin,
    Printer: SVGIconPrinter,
    SVGIconSaveAsh: SVGIconSaveAsh,
    SVGIconGrayBroom: SVGIconGrayBroom,
    SVGIconGrayPrinter: SVGIconGrayPrinter,
    SVGIconArrowDuplo: SVGIconArrowDuplo,
    SVGIconBackSet: SVGIconBackSet,
    SVGIconReturnRightSet: SVGIconReturnRightSet,
    SVGIconArrowRightDuplo: SVGIconArrowRightDuplo,
    SVGIconCloseSmall: SVGIconCloseSmall,
    RoundedClose: SVGIconRoundedClose,
    Download: SVGIconDownload,
    Unlock: SVGIconUnlock,
    Lock: SVGIconLock,
    Duplicate: SVGIconDuplicate,
  },
);
